import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import React, { useEffect, useState, useRef } from "react";
import { deleteOrders, getOrders, adddeliveredOrders } from "../../Data/Orders";
import PrintIcon from "@mui/icons-material/Print";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import PrintCompoonet from "../../components/PrintCom";
import { firebase_Db } from "../../config/firebaseConfig";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import Button from "@material-ui/core/Button";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

const OrderProductsComponent = ({ items, index }) => {
  const [openMoreItems, setOpenMoreItems] = useState(false);
  const { data, id } = items;
  let Orderdate = data.dateCreated;
  let listOfProducts = data.products;
  let userData = data.User;
  const DBorders = "deliveredOrders";
  const [checked, setChecked] = React.useState(["order"]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleDeliveredOrders = async () => {
    listOfProducts.map(async (products, index) => {
      const { name, imgUrl, Price, quantity } = products;

      return await firebase_Db
        .collection(DBorders)
        .add({
          id: userData.userid,
          user: userData,
          product_name: name,
          product_price: Price,
          product_imgUrl: imgUrl,
          product_quantity: quantity,
          delivered: true,
        })
        .then(() => {
          deleteOrders(id);
          return alert("Product add to Delivered Orders");
        })
        .catch((e) => {
          return alert("Error: Item not added to delivered orders");
        });
    });
  };

  return (
    <>
      <List key={id}>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonRoundedIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={`Name: ${data.User.name}`}
            secondary={`email: ${data.User.email}`}
          />
          <ListItemText
            primary={`phone: ${data.User.phone}`}
            secondary={`Order Date: ${Orderdate.toDate().toGMTString()}`}
          />

          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete">
              <DeleteIcon
                color="error"
                fontSize="large"
                onClick={async (_) => {
                  deleteOrders(id);
                  alert("Product Deleted");
                }}
              />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => setOpenMoreItems(!openMoreItems)}
            >
              {openMoreItems ? (
                <ExpandLessRoundedIcon color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRoundedIcon color="primary" fontSize="large" />
              )}
            </IconButton>
            <Switch
              edge="end"
              onChange={handleToggle("order")}
              checked={checked.indexOf("order") !== -1}
              inputProps={{
                "aria-labelledby": "switch-list-label-order",
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
        {openMoreItems &&
          listOfProducts.map((products, index) => {
            const { name, imgUrl, Price, place, quantity, cate } = products;
            return (
              <>
                <ListItem key={index}>
                  <ListItemAvatar>
                    <Avatar sx={{ width: 50, height: 50 }} src={imgUrl} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`Product Name: ${name}`}
                    secondary={`price: Ghc${Price}  `}
                  />
                  <ListItemText
                    primary={`Quantity: ${quantity}`}
                    secondary={`Cate: ${cate} ,  sub:${place}`}
                  />
                </ListItem>
              </>
            );
          })}

        <hr style={{ color: "orange" }} height="10px" />
        <Divider dark />
        <center key={id}>
          <div key={id}>
            <Button
              variant="contained"
              color="primary"
              onClick={async (_) => {
                handleDeliveredOrders();
              }}
            >
              Mark as Deliverd
            </Button>
          </div>
        </center>
      </List>
      <Divider dark />

      <br />
      <br />
      <Divider dark />
    </>
  );
};

export default OrderProductsComponent;
